import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import { clipList } from "store/schemas";

import magnifiAPI from "../../services/api/magnifi";

export const getRuleConfiguration = createAsyncThunk("ruleConfiguration/getRuleConfiguration", async (payload) => {
  try {
    const response = await magnifiAPI.getRuleConfiguration(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getRuleConfigurations = createAsyncThunk("ruleConfiguration/getRuleConfigurations", async (payload) => {
  try {
    const response = await magnifiAPI.getRuleConfigurations(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateRuleConfigurationScope = createAsyncThunk(
  "ruleConfiguration/updateRuleConfigurationScope",
  async (payload) => {
    try {
      const response = await magnifiAPI.updateRuleConfigurationScope(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const updateRuleConfiguration = createAsyncThunk(
  "ruleConfiguration/updateRuleConfiguration",
  async (payload) => {
    try {
      const response = await magnifiAPI.updateRuleConfiguration(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);

export const createRuleConfiguration = createAsyncThunk(
  "ruleConfiguration/createRuleConfiguration",
  async (payload) => {
    try {
      const response = await magnifiAPI.createRuleConfiguration(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);

export const listRuleConfigurations = createAsyncThunk("ruleConfiguration/listRuleConfigurations", async (payload) => {
  try {
    const response = await magnifiAPI.listRuleConfigurations(payload);

    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const listRuleConfigurationFilters = createAsyncThunk(
  "ruleConfiguration/listRuleConfigurationFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.listRuleConfigurationFilters(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getFilterTemplates = createAsyncThunk("ruleConfigurationV2/getFilterTemplates", async (payload) => {
  try {
    const response = await magnifiAPI.getFilterTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getFilterTemplateById = createAsyncThunk("ruleConfigurationV2/getFilterTemplateById", async (payload) => {
  try {
    const response = await magnifiAPI.getFilterTemplateById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createV2RuleConfiguration = createAsyncThunk(
  "ruleConfigurationV2/createV2RuleConfiguration",
  async (payload) => {
    try {
      const response = await magnifiAPI.createV2RuleConfiguration(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);

export const updateV2RuleConfiguration = createAsyncThunk(
  "ruleConfigurationV2/updateV2RuleConfiguration",
  async (payload) => {
    try {
      const response = await magnifiAPI.updateV2RuleConfiguration(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);

export const getV2RuleConfiguration = createAsyncThunk(
  "ruleConfigurationV2/getV2RuleConfiguration",
  async (payload) => {
    try {
      const response = await magnifiAPI.getV2RuleConfiguration(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);

export const triggerRuleConfiguration = createAsyncThunk(
  "ruleConfiguration/triggerRuleConfigurationManual",
  async (payload) => {
    try {
      const response = await magnifiAPI.triggerRuleConfiguration(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);

export const listRuleGeneratedContent = createAsyncThunk(
  "ruleConfiguration/listRuleGeneratedContent",
  async ({ entityId, ruleId, payload }) => {
    try {
      const response = await magnifiAPI.listRuleGeneratedContent({ entityId, ruleId, payload });

      return {
        ...response.data,
        ...(response.data.status ? normalize(response?.data?.data?.content || [], [clipList]) : {}),
      };
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);
